module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/doctrine/~/isarray/index.js
// module id = 2587
// module chunks = 0